module.exports = __webpack_public_path__ + "img/verticalconfig.fd902b53.svg";